import { coreDefaultTheme } from '@kite-js/theme';
import { coreRurubuTheme } from './theme-rurubu';
import { ULTheme, ULThemeBuilder } from '@theme/types';

const RurubuThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...coreRurubuTheme,
        logoUrl: 'https://cdn6.agoda.net/images/MVC/default/rurubu_logo.svg',
        background: {
            image:
                'url(https://cdn6.agoda.net/images/rurubu/home/hp-rurubu-02.png), linear-gradient(rgb(121, 193, 204), rgb(190, 224, 208))',
            position: 'center bottom',
            size: 'contain',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/default/favicon/rurubu/rurubu-favicon@2x.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        card: {
            ...coreDefaultTheme.card,
            borderRadius: 'M',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    // TODO: this is not good, but I use it for around for MSPA
    // please, unify and remove when we take over MSPA login 💪
    if (appId === 'mspa') {
        theme.background = {
            image: 'url(https://cdn6.agoda.net/images/mobile/RU-mweb-hp02.png)',
            position: '0 0',
            size: '100% 100%',
        };
    }

    return theme;
};

export default RurubuThemeBuilder;
